declare namespace $ {

	export class $mol_icon_file_document extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=document.view.tree.d.ts.map